import $ from 'jquery'

export default class ImagePreloader {
    constructor() {
        this._interval = null;
        this._onload = function () {
        };
        this._oncancel = function () {
        };
        this._current_cancel = function () {
        };
    }

    onLoad(fnc) {
        this._onload = fnc;
        return this;
    }

    onCancel(fnc) {
        this._oncancel = fnc;
        return this;
    }

    preload(images) {
        if (this.isPreloading()) {
            clearInterval(this._interval);
            this._current_cancel.call(this);
        }
        this._current_cancel = this._oncancel;
        this._image_load_info = [];
        this._images = images;
        this._loaded = 0;
        for (var i = 0; i < this._images.length; i++) {
            (function (image_load_info, i) {
                this._image_load_info[i] = image_load_info;
                // var $i =
                $('<img />')
                    .on('load', (function () {
                        this._loaded++;
                        image_load_info['loaded'] = true;
                    }).bind(this))
                    .attr("src", this._images[i]);
            }).call(this, { image: this._images[i], loaded: false }, i);
        }

        this._interval = setInterval((function () {
            if (this._images.length === this._loaded) {
                clearInterval(this._interval);
                this._interval = null;
                this._onload.call(this);
                this._onload = function () { };
            }
        }).bind(this), 50);
    }

    isPreloading() {
        return this._interval !== null;
    }

    cancel() {
        clearInterval(this._interval);
        this._oncancel.call(this)
    }
}

